import React, { Component } from "react";
import "./App.css";
import * as contentful from "contentful";
import ApiKey from "./constants/contentful";
import Session0425 from "../src/pages/session0425";
import Session0529 from "../src/pages/session0529";
import Session0614 from "../src/pages/session0614";
import { BrowserRouter, Switch, Route } from "react-router-dom";

class App extends Component {
  client = contentful.createClient(ApiKey);
  state = {
    companies: [],
    companies0529: [],
    university0425: [],
    companies0614: [],
  };
  componentDidMount() {
    this.client
      .getEntries({
        order: "-sys.createdAt",
        "sys.contentType.sys.id": "companies",
      })
      .then((response) => {
        this.setState({
          companies: response.items,
        });
      });
    this.client
      .getEntries({
        order: "-sys.createdAt",
        "sys.contentType.sys.id": "companies0529",
      })
      .then((response) => {
        this.setState({
          companies0529: response.items,
        });
      });
    this.client
      .getEntries({
        order: "-sys.createdAt",
        "sys.contentType.sys.id": "university0425",
      })
      .then((response) => {
        this.setState({
          university0425: response.items,
        });
      });
    this.client
      .getEntries({
        order: "-sys.createdAt",
        "sys.contentType.sys.id": "companies0614",
      })
      .then((response) => {
        this.setState({
          companies0614: response.items,
        });
      });
  }

  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route
            exact
            path="/"
            render={() => <Session0425 companies={this.state.companies} />}
          />
          <Route
            exact
            path="/session0529"
            render={() => <Session0529 companies={this.state} />}
          />
          <Route
            exact
            path="/session0614"
            render={() => <Session0614 companies={this.state} />}
          />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;
